import React, { useReducer } from "react";
import ResourceTypeContext from "./ResourceTypeContext";
import ResourceTypeReducer from "./ResourceTypeReducer";
import { getAccessResourceTypesService } from "../../services/resourceType";

const ResourceTypeState = ({ children }) => {

    const initialState = {
        resourcesTypes: [],
        wasFetched: false,
        isFetching: true,
    }

    const [state, dispatch] = useReducer(ResourceTypeReducer, initialState);

    const getResourceTypes = async () => {
        try {
            if (state.wasFetched === false) {
                const resources = await getAccessResourceTypesService();
                if (resources.ok) {
                    dispatch({
                        type: 'GET_ALL_RESOURCES_TYPES',
                        payload: resources.data.response
                    });
                }
            }
        } catch (e) {
            console.log(e);
        }
    }

    return (
        <ResourceTypeContext.Provider
            value={{
                resourceState: state,
                getResourceTypes
            }}>
            {children}
        </ResourceTypeContext.Provider>
    )
}

export default ResourceTypeState